import { IRoomRectangle } from "../../../types/Floorplan.types";

export interface IRectCanvasControlsProps {
    rects: IRoomRectangle[];
    selectedFloorIdx?: number;
    type: "Floor" | "Room";
}

const RectCanvasControls = (props: IRectCanvasControlsProps) => {
    const { rects, selectedFloorIdx } = props;
    if (selectedFloorIdx !== undefined) {
        const selectedFloorRect = rects[selectedFloorIdx];
        if (selectedFloorRect) {
            const x = selectedFloorRect.x+(selectedFloorRect.width! / 2);
            const y = selectedFloorRect.y+(selectedFloorRect.height! / 2);
            let radius = Math.max(selectedFloorRect.width!, selectedFloorRect.height!);
            if (radius > 50) radius = 50;
            if (radius < 15) radius = 15;
            // const handleX = selectedFloorRect.x + ((selectedFloorRect.width! / 2) + radius);
            // const handleY = selectedFloorRect.y;
            return (
                <svg id={`${props.type.toLowerCase()}ControlHandles`} x={x} y={y} overflow="visible">
                    <g transform={`rotate(${rects[selectedFloorIdx].rotation})`}>
                        <circle cx="0" cy="0" r={radius} stroke="#b7b7b7" strokeDasharray="4" fill="none" />
                        <circle id={`${props.type.toLowerCase()}RotationHandle`} cx={radius} cy={0 - radius} r="2" stroke="#999" strokeWidth="0.5" fill="white" />
                    </g>
                </svg>
            );
        }
    }
    return null;
};

export default RectCanvasControls;